import differenceInYears from 'date-fns/esm/differenceInYears'
import formatDistanceToNow from 'date-fns/esm/formatDistanceToNow'
import fr from 'date-fns/locale/fr'

export function minutesToDuration(minutes?: number, hideZeroMinute = false, withSpace = true) {
    if (minutes === null || minutes === undefined) return ''
    const hour = Math.floor(minutes / 60);
    const min = minutes % 60;

    return withSpace ?
        `${hour} h${(!min && hideZeroMinute) ? '' : ' ' + min.toString().padStart(2, '0')}`
        :
        `${hour}h${(!min && hideZeroMinute) ? '' : min.toString().padStart(2, '0')}`
}


/** (year * 100) + month (1..12) */
export type MonthYear = number
export type Minutes = number
export type Days = number


/** lun. 1 / mar. 2 / ... */
export const DAY_FORMATER = new Intl.DateTimeFormat('fr-FR', { weekday: 'short', day: 'numeric' })

/** lundi / mardi / ... */
export const WEEKDAY_FORMATER = new Intl.DateTimeFormat('fr-FR', { weekday: 'long' })

const MONTH_FORMATER = new Intl.DateTimeFormat('fr-FR', { year: 'numeric', month: 'long' })


export default defineNuxtPlugin(() => ({
    provide: {
        format: {

            /**
             * LocaleDateString UTC. ex: fr => 25/02/2012
             * @param date Date.getTime()
             */
            date(date?: number | Date, hour = false) {
                if (!date) return ''
                try {
                    if (typeof date === 'number') date = new Date(date)
                    return hour ?
                        date.toLocaleString('fr-FR', { timeZone: 'Etc/GMT', dateStyle: 'short', timeStyle: 'short' })
                        :
                        date.toLocaleDateString('fr-FR', { timeZone: 'Etc/GMT' })
                } catch (e: any) {
                    console.warn(e)
                    return ''
                }
            },

            distanceToNow(dateA: number | Date) {
                return formatDistanceToNow(dateA, { locale: fr, addSuffix: true })
            },

            differenceInYears(dateA: number | Date, dateB: number | Date = new Date()) {
                return differenceInYears(dateB, dateA)
            },

            dateISO(date?: number | Date) {
                if (!date) return ''
                if (typeof date === 'number') date = new Date(date)
                return date.toISOString()
            },

            number(v: number, precision = 0, unit = "") {
                return new Intl.NumberFormat('fr', {
                    maximumFractionDigits: precision,
                    useGrouping: true,
                    minimumFractionDigits: precision
                }).format(v) + unit
            },

            /**
             * @param ym year (ex:2012) or monthYear (ex:201202)
             * @param m month 1..12
             * @returns Ex: février 2025
             */
            monthYear(ym: MonthYear | number, m?: number) {
                if (ym === undefined) return ''
                if (m !== undefined)
                    return MONTH_FORMATER.format(new Date(ym, m - 1, 1))
                return MONTH_FORMATER.format(new Date(Math.floor(ym / 100), (ym % 100) - 1, 1))
            },

            minutesToDuration,

            WEEKDAY_FORMATER
        }
    }
}))